import $ from 'jquery'

function initTeamBlock () {
  const $teamBlock = $('.team-block')

  if (!$teamBlock.length) return

  $teamBlock.each(function () {
    const $block = $(this)
    const $members = $block.find('.team-block__item')
    const $departmentFilter = $block.find('#team-department-filter')
    const $locationFilter = $block.find('#team-location-filter')

    function filterMembers () {
      const selectedDepartment = $departmentFilter.val()
      const selectedLocation = $locationFilter.val()

      $members.each(function () {
        const $member = $(this)
        const memberDepartments = $member.data('department') ? $member.data('department').toString().split(',') : []
        const memberLocations = $member.data('location') ? $member.data('location').toString().split(',') : []

        const matchesDepartment = selectedDepartment === 'all' || memberDepartments.includes(selectedDepartment)
        const matchesLocation = selectedLocation === 'all' || memberLocations.includes(selectedLocation)

        if (matchesDepartment && matchesLocation) {
          $member.show()
        } else {
          $member.hide()
        }
      })
    }

    $departmentFilter.on('change', filterMembers)
    $locationFilter.on('change', filterMembers)

    // Initial filter on page load
    filterMembers()
  })
  
}

export { initTeamBlock }
